import http from '../../http';
import { SERVER_URL } from '../../config';

export const getSchedulePageData = (params) => http.get(`${SERVER_URL}/api-main/v1/schedule`, { params: { ...params } });
